var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconValuepropositioncanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-valuepropositioncanvas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17385",
    "data-name": "Ret\\xE2ngulo 17385",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12790",
    "data-name": "Grupo 12790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7296",
    "data-name": "Caminho 7296",
    d: "M19.374,6.18H4.627V5H19.374ZM20.006,3H3.994A1.446,1.446,0,0,0,2.627,4.511V6.669A1.446,1.446,0,0,0,3.994,8.18H20.006a1.447,1.447,0,0,0,1.368-1.511V4.511A1.447,1.447,0,0,0,20.006,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7297",
    "data-name": "Caminho 7297",
    d: "M8.609,19H4.627V11.385H8.609Zm.73-9.615H3.9a1.272,1.272,0,0,0-1.271,1.27V19.73A1.271,1.271,0,0,0,3.9,21H9.339a1.271,1.271,0,0,0,1.27-1.27V10.655a1.271,1.271,0,0,0-1.27-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7298",
    "data-name": "Caminho 7298",
    d: "M19.052,12.6h-4.19V11.385h4.19Zm.7-3.211H14.165a1.305,1.305,0,0,0-1.3,1.3v2.606a1.3,1.3,0,0,0,1.3,1.3h5.584a1.3,1.3,0,0,0,1.3-1.3V10.688a1.305,1.305,0,0,0-1.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7299",
    "data-name": "Caminho 7299",
    d: "M19.052,19h-4.19V17.787h4.19Zm.7-3.211H14.165a1.305,1.305,0,0,0-1.3,1.3V19.7a1.3,1.3,0,0,0,1.3,1.3h5.584a1.3,1.3,0,0,0,1.3-1.3V17.09a1.305,1.305,0,0,0-1.3-1.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValuepropositioncanvas);
export default __webpack_public_path__ + "static/media/icon-valuepropositioncanvas.c7c87b74b98d687c696d0bd36a713ccb.svg";
export { ForwardRef as ReactComponent };